import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
	providedIn: 'root',
})
export class TagsService {
	constructor(private translate: TranslateService) {}

	validateTags(tags: string): string | null {
		if (!this.tagStringHasErrors(tags)) return null;
		return this.translate.instant('docs.mappings.validate.mappings_tags_mustbekeyvalueunique');
	}

	tagStringHasErrors(tags: string): boolean {
		return !/^(?!.*(,|^)\s*(\s*\w+\s*)=[\w\s;.]*\1.*\b\2=[\w\s;.]+\b)(\s*\w[\w\s]*=[\w\s;.]+(?:,\s*\w[\w\s]*=[\w\s;.]+)*)(?<!\s)$/.test(tags);
	}

	tagArrayHasErrors(tagArray: tagArray): boolean {
		return this.tagStringHasErrors(this.tagArrayToString(tagArray));
	}

	tagArrayToString(tagArray: tagArray): string {
		return Object.entries(tagArray)
			.map(([key, value]) => `${key}=${value}`)
			.join(', ');
	}

	tagStringToArray(tagString: string): tagArray {
		if (!tagString?.trim() || tagString === 'null') {
			return {};
		}
		return Object.fromEntries(tagString.split(',').map((tag) => tag.split('=').map((part) => part.trim())));
	}
}

export interface tagArray {
	[key: string]: string;
}
